<template>
  <div class="header">
  </div>
</template>

<script>
import responsitiveData from '@/mixins/responsitiveData.vue'

export default {
  mixins: [
    responsitiveData
  ]
}
</script>
